import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface WorkspaceSettingsUIState {
  isDetailsDirty: boolean;
  isDetailsPending: boolean;
}

const initialState: WorkspaceSettingsUIState = {
  isDetailsDirty: false,
  isDetailsPending: false,
};

const workspaceSettingsUISlice = createSlice({
  initialState,
  name: 'workspaceSettingsUI',
  reducers: {
    resetWorkspaceSettingsUI: () => initialState,
    setDetailsDirty: (state, action: PayloadAction<boolean>) => {
      state.isDetailsDirty = action.payload;
    },
    setDetailsPending: (state, action: PayloadAction<boolean>) => {
      state.isDetailsPending = action.payload;
    },
  },
});

export const { resetWorkspaceSettingsUI, setDetailsDirty, setDetailsPending } =
  workspaceSettingsUISlice.actions;
export default workspaceSettingsUISlice.reducer;
